module.exports = __webpack_public_path__ + "img/jackpot-disable.2ba4b389.png";